import { render, staticRenderFns } from "./goodsdetails.vue?vue&type=template&id=3a5b76af&scoped=true"
import script from "./goodsdetails.vue?vue&type=script&lang=js"
export * from "./goodsdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b76af",
  null
  
)

export default component.exports